declare global {
  interface Window {
    dataLayer?: any[];
  }
}

export const GTM_ID = 'GTM-PGMQVMP2';

export function reportClientSideNavigation(url: string) {
  //TODO: extract into useAnalytics
  window.dataLayer?.push({
    event: 'client_side_navigation',
    page: url,
  });
}
